import { IS_LOADING, API_URL, GET_ERRORS, GET_INPUT_DATA } from "./types";
import axios from "axios";
import { tokenConfig } from "../utils/tokenConfig";

export const getInputData = (lat, lng, history) => async (dispatch) => {
  try {
    dispatch({
      type: IS_LOADING,
    });


    const [res1, res2, res3, res4, res5, res6] = await Promise.all([
      axios.get(`${API_URL}/points/irradiance_fixed_zero/?lat=${lat}&long=${lng}`, tokenConfig()),
      axios.get(`${API_URL}/points/irradiance_fixed_optimal/?lat=${lat}&long=${lng}`, tokenConfig()),
      axios.get(`${API_URL}/points/irradiance_inclined_optimal/?lat=${lat}&long=${lng}`, tokenConfig()),
      axios.get(`${API_URL}/points/irradiance_two_axis/?lat=${lat}&long=${lng}`, tokenConfig()),
      axios.get(`${API_URL}/points/windspeed/?lat=${lat}&long=${lng}`, tokenConfig()),
      axios.get(`${API_URL}/points/temperature/?lat=${lat}&long=${lng}`, tokenConfig())
    ])
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "irradiance_fixed_zero", value: res1.data },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "irradiance_fixed_optimal", value: res2.data },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "irradiance_inclined_optimal", value: res3.data },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "irradiance_two_axis", value: res4.data },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "windspeed", value: res5.data },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "temperature", value: res6.data },
    });
    // add also lat and long
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "lat", value: lat },
    });
    dispatch({
      type: GET_INPUT_DATA,
      payload: { key: "lng", value: lng },
    });
    dispatch({
      type: IS_LOADING,
    });
    history.push("/dashboard/data/input_data/irradiance_fixed_zero");
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};
